import React, { useContext, useEffect, useState } from 'react'
import Booking from '../Booking'
import './BookingRequest.css'

import {format, parseISO } from 'date-fns'

import api from '../../../Utils/Api';
import { CurrentUserContext } from '../../../Contexts/CurrentUserContext';
import { ru } from 'date-fns/locale';
import { JourneyContext } from '../../../Contexts/JourneyContext';
import Calendar from '../../Calendar/Calendar';
import { useLocation } from 'react-router-dom';

const status = {
  confirmed: 'Подтверждено',
  is_expecting: 'В рассмотрении',
  denied: 'Отклонено'
}

function BookingRequest() {
  const { token } = useContext(CurrentUserContext);
  const { currentPlace,setCurrentPlace } = useContext(JourneyContext);

  const [requests, setRequests] = useState([])

  // console.log(currentPlace);
  useEffect(() => {
    setCurrentPlace({ title:'Онлайн-запись'})
    api.getMyRequests(token).then((res) => {
      setRequests(res)
    }).catch((e) => {
      console.log(e);
    });
  }, [])

  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('')

  const handleOpenTab = (title) => {
   if (title === 'Календарь') {
        setTab(true)
        setTitle('_calendar') 
    } else if (title === 'Мои заявки') {
      setTitle('_request')
      setTab(false)
    }
  } 
  return (
    <div className='booking-page'>
      <div className='booking-page__body_wrap'>
          <Booking tab={tab} handleOpenTab={handleOpenTab} titleTag={titleTag} />
        <div className='tab__wrap'>
        {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
        
        </div>
        {tab && <div className='courses__calendar'><Calendar></Calendar></div>}
        {!tab && <div className='booking-page__body'>
          <div className='request' >
            <div className='request__table'> 
            <div className='request__table_label'>
              <div>Дата отправки</div>
              <div>Слот</div>
              <div>Курс</div>
              <div>Имя учителя</div>
              <div>Ваш комментарий</div>
              <div><span>Статус</span></div>
            </div>
            <div className='request__tableWrap'>
              {requests.map((r) => {
               const getColorByStatus = (status) => {
                switch (status) {
                  case 'В рассмотрении':
                    return '#7A5AF8';
                  case 'Подтверждено':
                    return '#22C532';
                  case 'Отклонено':
                    return '#F85A80';
                  default:
                    return 'black';
                }}
              return (
                <div className='request__table_item'>
                 <div>{format(parseISO(r.created_at), 'dd.MM.yyyy HH:mm:ss')}</div>
                  <div>{`${format(parseISO(r.slot_date), 'dd MMMM', { locale: ru })} ${r.start_time.slice(0, -3)} - ${r.end_time.slice(0, -3)}`}</div>
                  <div>{r.course_title}</div>
                  <div>{r.teacher_name}</div>
                  <div>{r.comment}</div>
                  <div style={{color: getColorByStatus(status[r.status])}}><span>{status[r.status]}</span></div>
                </div>
              )})
              }
              </div>
              </div>
          </div>
          </div>}
        </div>
    </div>

  )
}

export default BookingRequest